import { gql } from "@apollo/client";

// Reads via the standalone list query (not notificationSettings.installedBase):
// the federated settings path breaks for accounts with inconsistent setting
// containers, while this list stays reliable.
export const InstalledBaseIotReportSubscriptions = gql`
    query InstalledBaseIotReportSubscriptions {
        installedBaseIotReportSubscriptionList {
            total
            subscriptions(pagination: { limit: 100, start: 0 }) {
                id
                inApp
                mail
                push
                insert
                update
                client {
                    id
                    name
                }
            }
        }
    }
`;
